import useGameContext from '~/client/components/Game/context/Game/useGameContext';

const useCurrencyOptions = (selectedCurrency?: string) => {
  const { inGameCurrencyList } = useGameContext();
  const isBlankOptionSelected =
    !selectedCurrency ||
    !inGameCurrencyList?.some((currency) => currency === selectedCurrency);
  const baseOptions =
    inGameCurrencyList?.map((currency) =>
      createOption(currency, currency, currency === selectedCurrency),
    ) ?? [];
  const blankOption = [createOption('—', null, isBlankOptionSelected)];
  const options = [...baseOptions, ...blankOption];

  return options;
};

const createOption = (
  name: string,
  value: string | null,
  selected?: boolean,
) => ({
  name,
  value,
  selected,
});

export default useCurrencyOptions;
